import { createStore } from 'vuex'
import { supportedLocales } from '@/i18n'

export default createStore({
  state: {
    currentLocale: localStorage.getItem('locale') || 'zh'
  },
  getters: {
    // 获取当前语言
    currentLocale: (state) => state.currentLocale,
    
    // 获取当前语言名称
    currentLanguageName: (state) => {
      const current = supportedLocales.find(l => l.code === state.currentLocale);
      return current ? current.name : '简体中文';
    },
    
    // 获取支持的语言列表
    supportedLocales: () => supportedLocales,
    
    // 检查是否为RTL语言
    isRTL: (state) => state.currentLocale === 'ar'
  },
  mutations: {
    // 设置语言
    SET_LOCALE(state, locale) {
      state.currentLocale = locale;
    }
  },
  actions: {
    // 切换语言
    changeLanguage({ commit, dispatch }, langCode) {
      commit('SET_LOCALE', langCode);
      localStorage.setItem('locale', langCode);
      
      // 设置文档方向
      if (langCode === 'ar') {
        document.documentElement.dir = 'rtl';
        document.documentElement.lang = 'ar';
      } else {
        document.documentElement.dir = 'ltr';
        document.documentElement.lang = langCode;
      }
      
      // 更新 i18n 实例的语言
      this.$i18n.locale = langCode;
    }
  },
  modules: {
  }
})
